import { apollo } from '../../apollo'
import gql from 'graphql-tag'

const prefix = '_auth.'
const loginMutation = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, _password: $password) {
      id
      authToken
      fullName
      profilePhoto {
        id
        url
      }
      email
    }
  }
`
const checkQuery = gql`
  query {
    me {
      id
      authToken
    }
  }
`

const state = {
  isLogged: !!localStorage.getItem(prefix + 'token'),
  token: localStorage.getItem(prefix + 'token') || null,
  user: JSON.parse(localStorage.getItem(prefix + 'user')) || null
}

const mutations = {
  loginSuccess (state, payload) {
    state.token = payload.authToken
    state.user = payload

    localStorage.setItem(prefix + 'user', JSON.stringify(payload))
    localStorage.setItem(prefix + 'token', payload.authToken)
  },

  loginFail (state, payload) {
    state.token = state.user = null

    localStorage.removeItem(prefix + 'user')
    localStorage.removeItem(prefix + 'token')
  },

  logout (state, payload) {
    state.token = state.user = null
    apollo.resetStore() // reset apollo store, prevent conflicts

    localStorage.removeItem(prefix + 'user')
    localStorage.removeItem(prefix + 'token')
  },

  update (state, payload) {
    state.user = payload

    localStorage.setItem(prefix + 'user', JSON.stringify(payload))
  }
}

const actions = {
  login ({ commit }, params) {
    return new Promise((resolve, reject) => {
      apollo.mutate({
        mutation: loginMutation,
        fetchPolicy: 'network-only',
        variables: {
          ...params
        }
      }).then((response) => {
        if (response.data.login) {
          commit('loginSuccess', response.data.login)
          resolve({ success: true })
        } else {
          commit('loginFail')
          resolve({ success: false, error: 'fail' })
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  logout ({ commit }) {
    commit('logout')
  },
  check () {
    return new Promise((resolve, reject) => {
      apollo.query({
        query: checkQuery
      }).then((response) => {
        if (response.data.me) {
          resolve({ success: true, data: response.data.me })
        } else {
          resolve({ success: false, data: response.data.me })
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  update ({ commit }, payload) {
    commit('update', payload)
  }
}

const getters = {
  user (state, getters) {
    //
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js